module.exports = __webpack_public_path__ + "img/clogo.fb6dacbe.png";